import { type AxiosError } from "axios";
import api, { API_VERSIONS } from "@/config/api";
import { Recording } from "@/models/recording";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";

export const getRecordingTranscription = async ({
  recordingId,
  content,
}: {
  recordingId?: string;
  content?: number;
}): Promise<Recording | string | AxiosError | undefined> => {
  try {
    const initialToken = recoverTokenInfo();

    // Ensure content is within the allowed range
    let validContent = false;
    if (content == undefined) validContent = false;
    else if ([0, 1, 2, 3, 4].includes(content)) validContent = true;

    const res = await api.get(`/${API_VERSIONS.v0}/recording/${recordingId}`, {
      params: {
        ...(validContent && { content }),
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${initialToken}`,
      },
    });

    if (!content || content === 0) {
      // If content is 0, return the response directly
      return res.data as Recording;
    }

    // Fallback if data is not a Response object
    return String(res.data);
  } catch (error) {
    console.error("Error fetching recording transcription:", error);
    throw error;
  }
};
